import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { PqrTypification } from '../../../class/pqr-typification';
import { PqrTypificationService } from '../../../service/pqr-typification/pqr-typification.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-pqr-typification',
  templateUrl: './new-pqr-typification.component.html',
  styleUrls: ['./new-pqr-typification.component.scss']
})
export class NewPqrTypificationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: PqrTypification;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public name: AbstractControl;
    public activated: AbstractControl;
    public department_id: AbstractControl;
    public venueSelected: string;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public departmentService: PqrTypificationService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.save_exit = false;

        this.form = fb.group({
            'name': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'activated': ['', Validators.compose([Validators.required])],
            'department_id': ['', Validators.compose([Validators.required])]
        });

        this.name = this.form.controls['name'];
        this.activated = this.form.controls['activated'];
        this.department_id = this.form.controls['department_id'];
    }

    ngOnInit() {
        if (this.edit) {
            this.name.setValue(this.edit.name);
            this.activated.setValue(this.edit.activated);
            this.department_id.setValue(this.edit.department_id);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelPqrTypification () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newPqrTypification(values);
    }

    public newPqrTypification(values: PqrTypification) {
        const param = {
            'name': values.name,
            'activated': values.activated,
            'department_id': values.department_id
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.departmentService.updatePqrTypification(this.edit.id, param)
                :
                this.departmentService.newPqrTypification(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqr-typifications/new-pqr-typification/new-pqr-typification.component.ts